export { GuiaList } from "./guias/list/list";
export { DocumentacionList } from "./documentacion/list/list";
export { GuiaListMem, columnasFijas as guiaColumnasFijas } from "./guias/list/listmem";
export { GuiasIndex } from "./guias";
export { DocumentacionesIndex } from "./documentacion";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/index.tsx